import { Box, Paper, useTheme } from '@mui/material'
import LoginRightContent from './LoginRightContent';
import { useState } from 'react';
import SetTheme from '../common/SetTheme';

function LoginRight(props) {
  const theme1 = useTheme();
  // eslint-disable-next-line no-unused-vars
  const [theme, setTheme] = useState(props?.theme ? props.theme : theme1)
  
  // Check for dark theme
  const isDark = props.customDetails?.darkTheme === true || theme1.palette.mode === 'dark';

  return (
    <Box sx={{
      display: { xs: "none", sm: "none", md: "flex" },
      flexDirection: "column",
      justifyContent: "start",
      alignItems: "flex-start",
      flex: 2,
      backgroundColor: isDark ? '#161616' : (props?.customDetails?.loginRightBackground ?? props.customDetails.primaryColor),
      minHeight:'100%',
      padding: {
        md: "9.125rem 5.5rem",
        lg: "9.125rem 7.5rem"
      },
      borderLeft: props?.customDetails?.loginRightBorderColor ? `1px solid ${isDark ? '#7A8185' : props?.customDetails?.loginRightBorderColor}` : "0",
      color: isDark ? '#fff' : '#000',
      background:props?.customDetails?.loginCoverImage ? "transparent" : props.customDetails.primaryColor
    }}>
      <SetTheme customDetails={props.customDetails} setTheme={setTheme} />
      <Paper sx={{
        padding: "2.5rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "auto",
        border: props?.customDetails?.loginRightContentBorderColor ? `1px solid ${isDark ? '#7A8185' : props?.customDetails?.loginRightContentBorderColor}` : "0",
        backgroundColor: isDark ? '#161616' : '#fff',
        color: isDark ? '#fff' : '#000',
      }}>
        <LoginRightContent {...props} />
      </Paper>
    </Box>
  )
}

export default LoginRight